import React, { useState, useEffect, useContext } from "react";
import { Button, ModalBody, Row } from "reactstrap";
import { toast } from "react-toastify";
import Loader from "../common/Loader";
import AppContext from "../../context/Context";
import APICall from "../../services/apiCall";
import APIPortalTable from "../common/Table/APIPortalTable";

const apiTiersColumns = [
  {
    sort: true,
    csvExport: true,
    accessorKey: "sla_plan_name",
    header: "SLA Plan Name",
  },
  {
    sort: true,
    csvExport: true,
    accessorKey: "rate_limit_request",
    header: "Rate Limit",
    sortingFn: (rowA, rowB, columnId) => {
      let A_row = Number(rowA?.original[columnId]);
      let B_row = Number(rowB?.original[columnId]);
      if (A_row < B_row) {
        return -1;
      } else if (A_row > B_row) {
        return 1;
      } else {
        return 0;
      }
    },
    Cell: ({ row }) => {
      return (
        <>
          <span>
            {" "}
            <b>{row.original.rate_limit_request}</b> Requests/Minute
          </span>
        </>
      );
    },
  },
  {
    sort: true,
    csvExport: true,
    accessorKey: "throttle_limit",
    header: "Throttle Limit",
    sortingFn: (rowA, rowB, columnId) => {
      let A_row = Number(rowA?.original[columnId]);
      let B_row = Number(rowB?.original[columnId]);
      if (A_row < B_row) {
        return -1;
      } else if (A_row > B_row) {
        return 1;
      } else {
        return 0;
      }
    },
    Cell: ({ row }) => {
      return (
        <>
          <span>
            {" "}
            <b>{row.original.throttle_limit}</b> Requests/day
          </span>
        </>
      );
    },
  },
  {
    sort: true,
    csvExport: true,
    accessorKey: "limit_type",
    header: "Limit Type",
    sortingFn: (rowA, rowB, columnId) => {
      let A_row = Number(rowA?.original[columnId]);
      let B_row = Number(rowB?.original[columnId]);
      if (A_row < B_row) {
        return -1;
      } else if (A_row > B_row) {
        return 1;
      } else {
        return 0;
      }
    },
    Cell: ({ row }) => {
      return (
        <>
          <span>
            {" "}
            <b>
              {row.original.limit_type.charAt(0).toUpperCase() +
                row.original.limit_type.slice(1)}
            </b>{" "}
            Requests/Minute
          </span>
        </>
      );
    },
  },
  {
    sort: true,
    csvExport: true,
    accessorKey: "price_per_call",
    header: "Price per call",
  },
];

const UpdateAppSLAPlanModal = ({
  applicationData,
  setOpenUpdateAppSLAPlanModal,
  // setFetchAfterUpdate,
  setFetchApplicationDetails,
  partnerDetails,
}) => {
  const [loading, setLoading] = useState(false);
  const [apiTiersData, setApiTiersData] = useState([]);
  const [selectedSLAPlan, setSelectedSLAPlan] = useState({});
  const [selectedSlaPlanIndex, setSelectedSlaPlanIndex] = useState(
    applicationData.sla_plan_id
  );
  const [addRowRowSelection, setAddRowRowSelection] = useState({});
  const { loginUserDetails } = useContext(AppContext);
  const [isSame , setIsSame ] = useState(true)

  useEffect(() => {
    setLoading(true);
    let params={
      devid:loginUserDetails.dev_id
    }
    APICall.servertrip("GET", "api_tiers", loginUserDetails,params).then(
       (res) => {
      setApiTiersData(res.data.items);
      const initialId = String(applicationData.sla_plan_id);
      
      setAddRowRowSelection({
        [initialId]: true
      });
      setSelectedSlaPlanIndex(initialId);
      setLoading(false);
    },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        setLoading(false);
      }
     );
}, [applicationData.sla_plan_id]); 



  useEffect(() => {
    if (apiTiersData.length === 0) return;
    const addRowRowSelectionKeys = Object.keys(addRowRowSelection);
  const currentSelectedId = addRowRowSelectionKeys[0];
  const selectedPlan = apiTiersData.find((item) => {
    return item.sla_plan_id == addRowRowSelectionKeys[0];
  });
    if(selectedPlan){
      setSelectedSLAPlan(selectedPlan);
    setSelectedSlaPlanIndex(selectedSLAPlan?.sla_plan_id);

    if (applicationData?.sla_plan_id == selectedPlan?.sla_plan_id) {
      setIsSame(true);
    } else {
      setIsSame(false);
  }

    return () => {
      setIsSame(true);
    };
    }
}, [addRowRowSelection,apiTiersData]); 

  const handleUpdateSLAPlan = () => {
    setLoading(true);
    let body = {
      sla_plan_id: selectedSLAPlan.sla_plan_id,
      sla_plan_name: selectedSLAPlan.sla_plan_name,
      app_id: applicationData.app_id,
      application_name: applicationData.app_name,
      partner_name: partnerDetails.partner_name,
      add_updated_by: loginUserDetails.user_name, //loggedin user's username
      is_add_updated_by_admin:
        loginUserDetails.is_partner === "0" ? "true" : "false",
      before_updated_value: {
        sla_plan_id: applicationData.sla_plan_id,
        sla_plan_name: applicationData.sla_plan_name,
      },
      user_dev_id:loginUserDetails.dev_id
    };

    APICall.servertrip(
      "POST",
      "set_sla_plan_for_application",
      loginUserDetails,
      undefined,
      body
    ).then(
      (res) => {
        toast.success("SLA Plan successfully updated");
        setOpenUpdateAppSLAPlanModal(false);
        // setFetchAfterUpdate(true);
        // setFetchApplicationDetails(true);
        // setLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        setLoading(false);
      }
    );
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <APIPortalTable
            data={apiTiersData}
            columns={apiTiersColumns}
            loading={loading}
            enablePagination
            CSVFileName={"Partner Apps SLA plans.csv"}
            enableRowSelection
            getRowId={(row) => row.sla_plan_id}
            muiTableBodyRowProps={({ row }) => ({
              onClick: row.getToggleSelectedHandler(),
              sx: { cursor: "pointer" },
            })}
            enableMultiRowSelection={false}
            onRowSelectionChange={setAddRowRowSelection}
            state={{ rowSelection: addRowRowSelection }}
          />
          <Row
            className="modal-footer px-md-4 bg-light mt-3"
            style={{
              marginBottom: "-16px",
              marginLeft: "-16px",
              marginRight: "-16px",
            }}
          >
            <Button
              color="outline-primary"
              size="sm"
              className="ml-auto"
              onClick={handleUpdateSLAPlan}
              disabled={isSame}
            >
              Save
            </Button>
            <Button
              color="outline-danger"
              size="sm"
              onClick={() => {
                setOpenUpdateAppSLAPlanModal(false);
              }}
            >
              Cancel
            </Button>
          </Row>
        </>
      )}
    </div>
  );
};

export default UpdateAppSLAPlanModal;
